<template>
    <div v-if="showLiContent">
        <dl class="row">
            <dt class="col-lg-3 col-sm-4 col-6 bold-text">
                <span class="dynamic" v-html="getLanguageHeader()"/>
                <span class="reg-text nor-text-new" v-if="showInflectionHeader">{{ $t('message.part-of-speach') }}</span>
            </dt>
            <dd
                :class="getDDClass()"
                data-type="ordbok"
            >
                <span v-if="getOrdbankResultHasContent(lemInfo)">
                    <norskOrdbankResultHeader
                        :snId="snId"
                        :langCode="getLangCode()"
                        :norskOrdbank="getOrdbankResultByEMor(lemInfo)"
                        :partOfSpeachInfo="partOfSpeachInfo"
                    />
                </span>
                <span v-else>
                    <template v-if="getOrdbankResultHasHeader(lemInfo)">
                        <norskOrdbankResultHeader
                          :snId="snId"
                          :langCode="getLangCode()"
                          :norskOrdbank="getOrdbankResultByEMor(lemInfo)"
                          :partOfSpeachInfo="partOfSpeachInfo"
                        />
                    </template>
                    <template v-else-if="katInfo">
                        <PartOfSpeachHeader
                          v-if="snId > 0"
                          :snId="snId"
                          :lemInfo="lemInfo"
                          :katInfo="katInfo"
                          :partOfSpeachInfo="partOfSpeachInfo"
                          :norskOrdbank="{}"
                        />

                        <a
                          v-if="showTtsButton(katInfo)"
                          class="tts-btn"
                          href="javascript:void(0)"
                          role="button"
                          onclick="javascript:tts(this);"
                          :aria-label="$t('message.play-tts')"
                          tabindex="0"
                        >
                        <img
                          class="pointer speaker-image"
                          :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg"
                        >
                        </a>
                        <br v-if="hasTextProperty(morInfo)"/>
                        <template v-if="hasTextProperty(morInfo)">
                          <span v-for="(morInfoText, key) in morInfo.text.split('&&')" v-if="typeof morInfo.text == 'string'" :key="key">
                              <br v-if="key > 0" />
                              <span v-if="typeof morInfoText == 'string'" v-html="'[' + morInfoText.trim() + ']'" ref="link13"></span>
                              <a class="tts-btn" role="button" href="javascript:void(0)" onclick="javascript:tts(this);" :aria-label="$t('message.play-tts')" tabindex="0">
                                <img  class="pointer speaker-image" :alt="$t('message.speech-synthesis_icon')" src="/images/speaker-small.svg">
                              </a>
                          </span>
                        </template>
                    </template>
                </span>
            </dd>
        </dl>
        <details
            v-if="getOrdbankResultHasContent(lemInfo)"
            :open="getDefaultOpen()"
            class="ordbank-inflection"
            ref="ordbankdetails"
            @toggle="changeOpenClose($event)"
        >
            <summary
                class="ordbank-main-summary"
                ref="ordbanksummaries"
                :title="$t('message.ordbank_click_for_more_info')"
                :data-hidetitle="$t('message.ordbank_click_for_hide_info')"
                :data-showtitle="$t('message.ordbank_click_for_more_info')"

            >
                <span class="show-inflection">{{ $t('message.ordbank_show_inflection') }}</span>
                <span class="hide-inflection">{{ $t('message.ordbank_hide_inflection') }}</span>
            </summary>
            <div class="dictionary-ordbank" v-if="lemInfo && getOrdbankResultByEMor(lemInfo)">
                <norskOrdbankResult
                    :snId="snId"
                    :norskOrdbank="getOrdbankResultByEMor(lemInfo)"
                    :norskOrdbankIndex="getResultIndex(languageCode)"
                    :defaultOpen="defaultOpen"
                    :defaultOpenPartisipp="false"
                    :showHeader="false"
                />
            </div>
        </details>
    </div>
</template>
<script>

import SpeakTextContent from "./SpeakTextContent.vue";
import norskOrdbankResult from "@/components/NorskOrdbankResult.vue";
import NorskOrdbankResultHeader from "@/components/NorskOrdbankResultHeader.vue";
import NorskOrdbankResultPronunciation from "@/components/NorskOrdbankResultPronunciation.vue";
import PartOfSpeachHeader from "./PartOfSpeachHeader.vue";

export default {
	name: 'norskOrdbankResultBlocks',
    components: {
        NorskOrdbankResultPronunciation,
        norskOrdbankResult,
        NorskOrdbankResultHeader,
        SpeakTextContent,
        PartOfSpeachHeader
    },
    data(){
        return {
            snId: 0,
            languageCode: "",
            lemInfo: {},
            katInfo: {},
            morInfo: {},
            resultIndex: {},
            norskOrdbank: {},
            partOfSpeachInfo: {},
        }
    },
	props:{
        norskOrdbankIndex: {
            required: false,
            default: ''
        },
        defaultOpen: {
            required: false,
            default: false
        },
        showHeader: {
            required: false,
            default: true
        },
        showInflectionHeader: {
            required: false,
            default: true
        },
        showLiContent: {
            required: false,
            default: false
        },
        initialBlockInfo: {
            required: false,
            default: () => ({})
        },
        secondLang: {
            required: false,
            default: ''
        }
	},
	mounted(){
        if (this.listLength(this.initialBlockInfo) > 0) {
            this.snId = this.initialBlockInfo.sn_id || 0;
            this.languageCode = this.initialBlockInfo.language_code;
            this.lemInfo = this.initialBlockInfo.lem_info || {};
            this.katInfo = this.initialBlockInfo.kat_info || {};
            this.morInfo = this.initialBlockInfo.mor_info || {};
            this.norskOrdbank = this.initialBlockInfo.norsk_ordbank || {};
            this.partOfSpeachInfo = this.initialBlockInfo.part_of_speach_info || {};
            this.resultIndex = this.initialBlockInfo.result_index || {};
        } else {
            this.snId = 0;
            this.languageCode = '';
            this.lemInfo = {};
            this.katInfo = {};
            this.morInfo = {};
            this.norskOrdbank = {};
            this.partOfSpeachInfo = {};
            this.resultIndex = {};
        }

        if (this.initialBlockInfo.second_lang || false) {
            this.secondLang = this.initialBlockInfo.second_lang;
        }
    },
	methods:{
        getLangCode() {
            let value = '';

            if (this.lemInfo !== undefined && this.lemInfo.type !== undefined && typeof this.lemInfo.type == "string") {
                value = this.lemInfo.type.split('-')[0] || '';
            } else if (this.katInfo !== undefined && this.katInfo.type !== undefined && typeof this.katInfo.type == "string") {
                value = this.katInfo.type.split('-')[0] || '';
            } else if (this.morInfo !== undefined && this.morInfo.type !== undefined && typeof this.morInfo.type == "string") {
                value = this.morInfo.type.split('-')[0] || '';
            }

            if (value === 'E' || value === 'N') {
                value = 'E-N';
            }

            return value;
        },
        changeOpenClose(event) {
            const summary = event.target.querySelector("summary");
            if (event.target.open) {
                summary.title = summary.dataset.hidetitle;
            } else {
                summary.title = summary.dataset.showtitle;
            }
        },
        getDDClass() {
            let value = 'col-lg-9 col-sm-8 col-6';
            // arabisk, dari, kurdisk sorani, persisk og urdu
            if (this.lemInfo !== undefined && this.lemInfo.lang !== undefined &&
                ['ARA', 'UR', 'KSO', 'PER', 'PRS'].includes(this.lemInfo.lang)) {
                value += ' urd-text';
            } else {
                value += ' nor-text';
            }

            return value;
        },
        getDefaultOpen() {
            let value = this.defaultOpen;

            if (window.innerWidth <= 600) {
                value = false;
            }

            return value;
        },
        getResultIndex(postFix) {
            return this.resultIndex + '-' + postFix;
        },
        getOrdbankResultHasContent(eLem) {
            let hasContent = false;

            if (this.listLength(eLem) > 0) {
                let result = this.getOrdbankResultByEMor(eLem);
                if (result && result.has_content != undefined) {
                    hasContent = result.has_content;
                }
            }

            return hasContent;
        },
        getOrdbankResultHasHeader(eLem) {
            let hasContent = false;
            let result = this.getOrdbankResultByEMor(eLem);
            if (result.ordklasse != undefined && result.ordklasse) {
                hasContent = true;
            }

            return hasContent;
        },
        getOrdbankResultByEMor(eLem) {
            return this.norskOrdbank;
        },
        getLanguageHeader() {
            let value = '';

            if (this.secondLang) {
                value = this.secondLang;
            } else if (this.languageCode === 'nob') {
                value = this.$t('message.bokmal');
            } else if (this.languageCode === 'nno') {
                value = this.$t('message.nynorsk');
            }

            return value;
        },
        getOrdbankId(norskOrdbank, name) {
            let value = name;

            if (typeof norskOrdbank == "object" && norskOrdbank.lemma_id != undefined) {
                value += "-" + norskOrdbank.lemma_id;
            }

            if (this.norskOrdbankIndex != undefined) {
                value += "-" + this.norskOrdbankIndex;
            }

            return value;
        },
        showTtsButton(katInfo) {
            let value = false;
            if (typeof katInfo == "object" && katInfo.lang != undefined) {
                if (this.languageCode === 'nob' && (katInfo.lang === 'E' || katInfo.lang === 'N')) {
                    value = true;
                } else if (this.languageCode === 'nno' && katInfo.lang === 'NNY') {
                    value = true;
                }
            }

            return value;
        },
        hasTextProperty(katInfo) {
            let value = false;
            if (typeof katInfo == "object" && katInfo.text != undefined && typeof katInfo.text == "string") {
                value = true;
            }

            return value;
        },
        listLength(list) {
            let value = 0;

            if (typeof list == "object" && Object.keys(list).length > 0) {
                value = Object.keys(list).length;
            }

            return value;
        }
    }
}
</script>
